"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Branch = function Branch(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M13.57 8.885a.321.321 0 01-.255-.507l2.184-3.117a.311.311 0 01.511 0l2.184 3.117a.321.321 0 01-.255.507H16.38v1.774c0 .834-.95 2.244-1.54 2.834l-1.66 1.66c-.353.352-.55.829-.55 1.326v1.777a.625.625 0 11-1.25 0V16.48a1.863 1.863 0 00-.549-1.326l-1.66-1.661c-.59-.59-1.54-2-1.54-2.834V8.885H6.07a.321.321 0 01-.256-.507L7.999 5.26a.311.311 0 01.511 0l2.184 3.117a.321.321 0 01-.256.507H8.883v1.774c-.002.497.196.974.549 1.325l2.285 2.286c.105.106.202.22.29.34a3.16 3.16 0 01.29-.34l2.286-2.286c.353-.35.55-.828.55-1.325V8.885H13.57z"
  }));
};

var _default = (0, _react.forwardRef)(Branch);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Branch, "Branch", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Branch.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Branch.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();